import { useEffect, useState } from 'react';

const STORAGE_KEY = 'jkapf:age-verified';

export default function AgeGate() {
  const [visible, setVisible] = useState(false);
  const [declined, setDeclined] = useState(false);

  useEffect(() => {
    try {
      if (window.localStorage.getItem(STORAGE_KEY) !== '1') {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    document.body.style.overflow = visible ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [visible]);

  if (!visible) return null;

  const confirm = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore storage errors
    }
    setVisible(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background-950/95 px-4 backdrop-blur-md">
      <div className="animate-fade-up w-full max-w-lg rounded-lg border border-background-800 bg-background-900 p-6 md:p-8">
        <div className="flex items-center gap-3">
          <span className="flex h-12 w-12 items-center justify-center rounded-md border border-accent-500/50 bg-accent-500/10 font-label text-lg font-bold text-accent-400">
            18+
          </span>
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.26em] text-foreground-600">Age Verification</p>
            <h1 className="mt-1 text-lg font-bold text-foreground-50">本站仅限成年人访问</h1>
          </div>
        </div>

        <p className="mt-5 text-sm leading-relaxed text-foreground-400">
          日韩成人电影是一个面向成年观众的影视资讯与影片介绍网站，内容涉及成人主题。进入前请确认您已年满 18 周岁，并自愿浏览相关内容。
        </p>
        <p className="mt-3 text-xs leading-relaxed text-foreground-600">
          本站不提供任何影片播放、下载或交易服务，所有介绍内容均为演示用虚构资料。
        </p>

        {declined ? (
          <div className="mt-6 rounded-md border border-background-700 bg-background-950 px-4 py-3 text-sm text-foreground-400">
            感谢配合。请关闭此页面，或等待年满 18 周岁后再访问。
          </div>
        ) : (
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <button
              type="button"
              onClick={confirm}
              className="w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              我已年满 18 周岁，进入本站
            </button>
            <button
              type="button"
              onClick={() => setDeclined(true)}
              className="w-full cursor-pointer whitespace-nowrap rounded-md border border-background-700 px-4 py-2.5 text-sm text-foreground-400 transition-colors hover:border-foreground-600 hover:text-foreground-200"
            >
              我未满 18 周岁
            </button>
          </div>
        )}
      </div>
    </div>
  );
}